import { useEffect } from 'react';

// Ref-counted so that stacking multiple modals doesn't unlock the body until the last
// one closes. Module-level state is shared across every hook instance.
let lockCount = 0;
let savedOverflow = '';
let savedPaddingRight = '';

const lock = () => {
  if (lockCount === 0) {
    const { body, documentElement } = document;
    // Compensate for the disappearing scrollbar to avoid a layout shift.
    const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
    savedOverflow = body.style.overflow;
    savedPaddingRight = body.style.paddingRight;
    body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      const current = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
      body.style.paddingRight = `${current + scrollbarWidth}px`;
    }
  }
  lockCount += 1;
};

const unlock = () => {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.style.overflow = savedOverflow;
    document.body.style.paddingRight = savedPaddingRight;
  }
};

/**
 * Locks body scroll while `active` is true. Safe across nested/stacked modals.
 */
export default function useScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    lock();
    return unlock;
  }, [active]);
}
